module.exports = __webpack_public_path__ + "media/images/flags/4x3/reu-0bf1dd02e64ce260e34416bf712bfc1e.svg";